export default class ShiftTasksActionsService {
  constructor(AlertService, ChooseService, ShiftTasksService, Utils, sdk, pluralizeFilter) {
    'ngInject';

    Object.assign(this, { AlertService, ChooseService, ShiftTasksService, sdk, pluralizeFilter });

    Utils.extendWithProps(sdk('shiftTasksActionHelpers'), this, [
      'hasAllSubtasksCompleted',
      'isCompleted',
      'isPending',
      'markTaskWithAllSubtasksAsCompleted',
    ]);
    Utils.extendWithProps(sdk('constants'), this, [
      'TASK_INSTANCE_COMPLETED_STATUS',
      'TASK_INSTANCE_PENDING_STATUS',
    ]);
  }

  async completeTask(taskInstance) {
    if (!this.isCompleted(taskInstance)) {
      await this.ShiftTasksService.updateStatus(
        taskInstance.id,
        this.TASK_INSTANCE_COMPLETED_STATUS
      );
      taskInstance.status = this.TASK_INSTANCE_COMPLETED_STATUS;
      this.AlertService.success('Task successfully completed.');
    }
    return taskInstance;
  }

  getIncompleteSubtaskQuestion(subtasks) {
    const incompletedSubtasksCount = subtasks.filter(this.isPending).length;
    const subtaskPluralized = this.pluralizeFilter(incompletedSubtasksCount, 'subtask');

    return `You have ${incompletedSubtasksCount} incompleted ${subtaskPluralized}.`;
  }

  async reopenTask(taskInstance) {
    if (this.isCompleted(taskInstance)) {
      await this.ShiftTasksService.updateStatus(taskInstance.id, this.TASK_INSTANCE_PENDING_STATUS);
      taskInstance.status = this.TASK_INSTANCE_PENDING_STATUS;
      this.AlertService.success('Task reopened successfully.');
    }
    return taskInstance;
  }
}
